/**
 * Turkish mobile numbers as the login form takes them (enjoyvent's panel login): the player types the national number
 * after a fixed +90, any common writing is accepted (0530…, 530…, +90 530…, spaces, brackets). Pure, Node-tested.
 * Only the API decides what is valid; this keeps the field tidy and catches obvious typos before a code is sent.
 */

/** The 10 national digits (5XXXXXXXXX) from whatever was typed or pasted; at most 10 digits, never more. */
export function nationalDigits(input: string): string {
  // "0090 530…" and "+90 530…" carry the country code; "0530…" carries the trunk zero.
  let digits = input.replace(/\D/g, "").replace(/^0+/, "");
  if (digits.startsWith("90") && (digits.length > 10 || /^\s*(\+|00)/.test(input))) digits = digits.slice(2);
  return digits.replace(/^0+/, "").slice(0, 10);
}

/** A Turkish mobile: 10 digits starting with 5 (the API checks the operator ranges). */
export function isTurkishMobile(input: string): boolean {
  return /^5\d{9}$/.test(nationalDigits(input));
}

/** The field's mask while typing: `530 784 73 21`. */
export function formatNational(input: string): string {
  const d = nationalDigits(input);
  const parts = [d.slice(0, 3), d.slice(3, 6), d.slice(6, 8), d.slice(8, 10)].filter(Boolean);
  return parts.join(" ");
}

/** Shown on the code step (the player's own number, on their own screen): `+90 530 784 73 21`. */
export function displayPhone(input: string): string {
  return `+90 ${formatNational(input)}`;
}

/** What the API is sent: the national number with its leading 0, the form the API normalises. */
export function apiPhone(input: string): string {
  return `0${nationalDigits(input)}`;
}

/** The four code boxes from a paste or an SMS autofill: digits only, at most four. */
export function codeDigits(input: string, length = 4): string[] {
  return input.replace(/\D/g, "").slice(0, length).split("");
}
